export default __webpack_public_path__ + "static/media/WayNene.ff21ace5.jpeg";